import {
	IVIPCertificatePipelineTest,
	createCertificatePipelineTest,
	checkCertificatePipelineTest
} from "@/loader";


export interface IVIPCertificatePipelineTestSealing extends IVIPCertificatePipelineTest {
	water?: boolean;
	air?: boolean;
	pressure?: string;
}

export function createCertificatePipelineTestSealing(): IVIPCertificatePipelineTestSealing {
	return {
		...createCertificatePipelineTest(),
		water: false,
		air: false,
		pressure: "",
	};
}

export function checkCertificatePipelineTestSealing(data: IVIPCertificatePipelineTestSealing) {
	checkCertificatePipelineTest(data);

	if (data.water === undefined) {
		data.water = false;
	}
	if (data.air === undefined) {
		data.air = false;
	}
	if (data.pressure === undefined) {
		data.pressure = "";
	}
}
